module.exports = __webpack_public_path__ + "static/media/ImgExcel2.eaa3fb61.svg";